import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bookcabinpuneforoutstation() {



  const cardData =
  {
    keyword: 'Book Cab in Pune for Outstation',
    heading: 'Sanavi Travels: Book Cab in Pune for Outstation',
    headingDescription: 'Sanavi Travels offers easy and reliable options to Book Cab in Pune for Outstation travel, providing safe, comfortable, and hassle-free transportation for families, corporate travelers, tourists, and groups planning long-distance journeys from Pune. Our fleet of well-maintained sedans, SUVs, and luxury cabs ensures spacious seating, air-conditioning, and ample luggage capacity for a smooth and relaxing ride. With professional chauffeurs, flexible one-way and round-trip outstation cab packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular destinations such as Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Aurangabad, Kolhapur, Gujarat, Rajasthan, and Bangalore. Choose Sanavi Travels to book trusted outstation cabs in Pune, delivering comfort, safety, and a seamless long-distance travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the seat of Peshwa administration, it features massive stone walls, grand gates like Delhi Darwaza, and sprawling courtyards. Though partially destroyed by fire, its remains reflect Maratha valor and heritage. The evening light-and-sound show vividly narrates Pune’s royal past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a prominent monument linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi. The palace’s lush gardens and peaceful ambiance attract history lovers and tourists."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol is adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the center of grand celebrations. It is known not only for devotion but also for its social and charitable initiatives."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort located on the outskirts of Pune, famous for the heroic sacrifice of Tanaji Malusare. Visitors can trek or drive to the fort and enjoy panoramic views of the Sahyadri ranges. The fort is popular for trekking, history exploration, and traditional local food like pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars and a serene sanctum. Despite being in a busy area, the temple offers a peaceful spiritual retreat in the heart of Pune."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses an extensive collection of over 20,000 artifacts representing India’s cultural heritage. The exhibits include musical instruments, traditional utensils, sculptures, and ornaments. The recreated Mastani Mahal is a major highlight, making it a must-visit for art and history enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city after climbing 103 steps. The Parvati Temple complex dates back to the Peshwa era and is dedicated to Lord Shiva and Goddess Parvati. It is a popular spot for sunrise and sunset views."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from around the world. It offers meditation programs, wellness therapies, and tranquil gardens. The ashram is a global center for mindfulness, relaxation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features bridges, water streams, and manicured lawns. The garden is ideal for morning walks, photography, family outings, and peaceful relaxation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure spot near Pune, especially during the monsoon. The scenic reservoir, surrounding hills, and cool breeze make it a favorite for evening outings and weekend picnics. It also serves as the gateway to Sinhagad Fort."
  }
]
,




"services": [
  {
    "name": "Book Cab in Pune for Outstation",
    "description": "Book Cab in Pune for Outstation provides a convenient, reliable, and comfortable travel solution for passengers planning trips outside Pune. Fully air-conditioned cabs with spacious seating and ample luggage capacity ensure a relaxed long-distance journey. Professional chauffeurs handle highway driving, route planning, and timely pickups, allowing passengers to travel stress-free. Ideal for families, corporate travelers, tourists, or solo passengers, this service offers flexible booking options, transparent pricing, and dependable outstation travel from Pune."
  },
  {
    "name": "Outstation Cab Booking Pune",
    "description": "Outstation Cab Booking Pune is designed for travelers looking for a smooth and organized way to book cabs for long-distance journeys. Passengers enjoy well-maintained, air-conditioned vehicles with professional drivers experienced in outstation routes. Suitable for one-way trips, round trips, weekend getaways, or extended vacations, this service prioritizes comfort, safety, punctuality, and easy booking for hassle-free travel."
  },
  {
    "name": "AC Outstation Cab Pune",
    "description": "AC Outstation Cab Pune ensures a cool and comfortable journey for long-distance travel from Pune. Fully air-conditioned vehicles provide spacious seating, smooth suspension, and ample luggage space, making them ideal for hot weather and extended trips. Experienced chauffeurs ensure safe driving, timely departures, and efficient route selection. Perfect for families, corporate groups, and tourists seeking comfort and reliability."
  },
  {
    "name": "Luxury Outstation Cab Pune",
    "description": "Luxury Outstation Cab Pune offers a premium travel experience for passengers who value comfort, style, and exclusivity. High-end, fully air-conditioned vehicles with modern interiors and superior ride quality make long journeys relaxing and enjoyable. Professional chauffeurs ensure punctuality, safety, and smooth navigation. Ideal for corporate executives, families, couples, or VIP travelers seeking a refined outstation travel experience from Pune."
  },
  {
    "name": "Family Outstation Cab Pune",
    "description": "Family Outstation Cab Pune is specially designed to meet the needs of families traveling outside Pune. Spacious vehicles with air-conditioning, comfortable seating, and sufficient luggage space ensure a pleasant journey for all age groups. Professional drivers prioritize safety and smooth driving, making this service perfect for vacations, religious trips, or family visits with complete peace of mind."
  },
  {
    "name": "Corporate Outstation Cab Pune",
    "description": "Corporate Outstation Cab Pune caters to business travelers and corporate groups requiring punctual, professional, and comfortable transport. Air-conditioned vehicles with clean interiors and experienced chauffeurs ensure a productive and stress-free journey. Ideal for meetings, conferences, site visits, and corporate tours, this service supports flexible scheduling, reliability, and a professional travel experience."
  },
  {
    "name": "Affordable Outstation Cab Pune",
    "description": "Affordable Outstation Cab Pune provides cost-effective travel options without compromising on comfort or safety. Fully air-conditioned vehicles with professional chauffeurs ensure a smooth and reliable journey at budget-friendly rates. Ideal for students, families, and group travelers looking for economical yet dependable outstation cab services from Pune."
  },
  {
    "name": "Chauffeur Driven Outstation Cab",
    "description": "Chauffeur Driven Outstation Cab offers a stress-free travel experience with experienced drivers handling long-distance routes, traffic, and highway driving. Passengers can relax in spacious, air-conditioned vehicles designed for comfort and safety. Suitable for families, corporate travelers, tourists, or solo passengers, this service guarantees professionalism, reliability, and peace of mind throughout the journey."
  },
  {
    "name": "Best Outstation Cab Pune",
    "description": "Best Outstation Cab Pune delivers a superior travel experience with well-maintained vehicles, professional chauffeurs, and customer-focused service. Fully air-conditioned cabs ensure comfort during long journeys, while timely pickups and safe driving enhance reliability. Ideal for families, corporate travelers, and tourists seeking top-quality outstation travel from Pune."
  },
  {
    "name": "Pune Outstation Taxi",
    "description": "Pune Outstation Taxi is a dependable solution for passengers traveling from Pune to nearby cities or long-distance destinations. Spacious, air-conditioned taxis with experienced drivers ensure comfort, safety, and punctuality. Flexible pickup and drop locations make this service suitable for families, corporate groups, and tourists planning outstation trips."
  },
  {
    "name": "Tourist Outstation Cab Pune",
    "description": "Tourist Outstation Cab Pune is ideal for travelers planning leisure trips, sightseeing tours, or holiday travel from Pune. Comfortable, air-conditioned vehicles with knowledgeable chauffeurs provide a smooth and enjoyable journey. Suitable for families, groups, and solo tourists, this service supports customized itineraries and relaxed long-distance travel."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "Long Distance Cab Pune specializes in providing safe, comfortable, and reliable transport for extended journeys from Pune. Fully air-conditioned vehicles with spacious interiors and professional drivers ensure a stress-free experience. Ideal for family vacations, corporate travel, religious tours, or leisure trips, this service focuses on comfort, safety, and punctuality."
  },
  {
    "name": "One Way Outstation Cab Pune",
    "description": "One Way Outstation Cab Pune offers a convenient and economical option for travelers who do not require a return trip. Air-conditioned vehicles with professional chauffeurs ensure a smooth, safe, and timely journey. Ideal for relocations, business travel, or personal trips, this service provides flexibility and cost efficiency for one-way outstation travel."
  },
  {
    "name": "Round Trip Cab Pune",
    "description": "Round Trip Cab Pune is perfect for travelers planning to return to Pune after visiting an outstation destination. Fully air-conditioned, well-maintained vehicles with experienced chauffeurs ensure comfort and safety throughout the journey. Suitable for family vacations, corporate tours, or group travel, this service offers flexibility, reliability, and convenience for round-trip travel."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows passengers to easily book outstation cabs from anywhere at any time. Users can choose vehicle type, pickup and drop locations, travel dates, and trip type with instant confirmation. Fully air-conditioned vehicles and professional chauffeurs ensure a smooth, safe, and reliable journey, making online booking simple, fast, and stress-free."
  }
],
"tableData": [
  ["Book Cab in Pune for Outstation", "Outstation Cab Booking Pune"],
  ["AC Outstation Cab Pune", "Luxury Outstation Cab Pune"],
  ["Family Outstation Cab Pune", "Corporate Outstation Cab Pune"],
  ["Affordable Outstation Cab Pune", "Chauffeur Driven Outstation Cab"],
  ["Best Outstation Cab Pune", "Pune Outstation Taxi"],
  ["Tourist Outstation Cab Pune", "Long Distance Cab Pune"],
  ["One Way Outstation Cab Pune", "Round Trip Cab Pune"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Book Cab in Pune for Outstation with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers easy and reliable outstation cab booking services from Pune, perfect for family trips, corporate travel, long-distance journeys, and weekend getaways."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced cabs for a smooth and enjoyable journey to your chosen outstation destination."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with major outstation routes, ensuring safe and punctual travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront pricing for outstation cab bookings from Pune, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized outstation cab packages based on your travel plans and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for outstation cab bookings from Pune."
  }
]

}

const faqData = [
  {
    question: 'Can I book a cab in Pune for outstation travel with Sanavi Travels?',
    answer: 'Yes, Sanavi Travels provides comfortable and reliable cab services for outstation travel from Pune.'
  },
  {
    question: 'How do I book an outstation cab from Pune?',
    answer: 'You can easily book through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of outstation cabs are available?',
    answer: 'Sanavi Travels offers a range of vehicles including sedans, SUVs, and premium cars suitable for long-distance travel.'
  },
  {
    question: 'Are drivers experienced with outstation routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with major outstation routes to ensure safe and smooth travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup in Pune and drop-off at any outstation destination.'
  },
  {
    question: 'Is the outstation cab service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock cab services to match your travel schedule.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for booking?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during my journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your outstation cab trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni',
    feedback: 'Booked a cab in Pune for outstation travel with Sanavi Travels. Very comfortable ride and professional driver. Exceptional service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Richa Deshmukh',
    feedback: 'Excellent outstation cab service! The cab was clean, timely, and journey was hassle-free. Highly recommend Sanavi Travels.',
    rating: 5
  }
];























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Book Cab in Pune for Outstation - Sanavi Travels",
  "description": "Book outstation cabs in Pune with Sanavi Travels. AC and luxury cabs for family trips, corporate travel, long-distance journeys, one-way or round trips, tourist travel, and chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Book Cab in Pune for Outstation | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury outstation cabs from Pune with Sanavi Travels. Perfect for family trips, corporate travel, long-distance journeys, one-way or round trips, tourist travel, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/170.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bookcabinpuneforoutstation;